import CloseIcon from '@mui/icons-material/Close'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import { IconButton, InputAdornment } from '@mui/material'
import { ConsoleTooltip } from '@/components/ConsoleTooltip'

import { SELECT_BOX_TEST_IDS } from '../SelectBox.constants'

type SelectEndAdornmentProps = {
  disabled?: boolean
  disabledInfo?: string
  hasValue: boolean
  clearable?: boolean
  onClear?: () => void
}

export const SelectEndAdornment = ({
  disabled,
  disabledInfo,
  hasValue,
  clearable,
  onClear
}: SelectEndAdornmentProps) => {
  const shouldDisplayDisabledInfo = !!(disabled && disabledInfo)
  const shouldDisplayClearButton = !!(clearable && hasValue && !disabled)

  if (shouldDisplayDisabledInfo) {
    return (
      <InputAdornment
        position="end"
        sx={{
          position: 'absolute',
          top: '50%',
          right: 32
        }}
        data-testid={SELECT_BOX_TEST_IDS.disabledInfo}
      >
        <ConsoleTooltip title={disabledInfo} placement="top" arrow distance={8}>
          <InfoIcon sx={{ opacity: 0.7 }} />
        </ConsoleTooltip>
      </InputAdornment>
    )
  }

  if (shouldDisplayClearButton) {
    return (
      <InputAdornment
        position="end"
        sx={{
          position: 'absolute',
          right: 36
        }}
      >
        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            onClear?.()
          }}
          edge="end"
          data-testid={SELECT_BOX_TEST_IDS.clearButton}
        >
          <CloseIcon sx={{ transform: 'translateY(1px)' }} />
        </IconButton>
      </InputAdornment>
    )
  }

  return null
}
